import angular from "angular";
import moment from "moment";
import { directiveFactory } from "../../angular-core";

export class DateBeforeOtherDateValidationDirective implements ng.IDirective {
    static componentName: string = "dateBeforeOtherDateValidation";

    require = "ngModel";
    restrict = "A";

    link = (scope: $TSFixMe, element: JQLite, attrs: ng.IAttributes, ngModel: $TSFixMe) => {
        scope.$watch(attrs.otherDate, function () {
            ngModel.$validate();
        });
        ngModel.$validators.dateBeforeOtherDate = function (modelValue: $TSFixMe, viewValue: $TSFixMe) {
            var value = modelValue || viewValue;

            var otherDate = scope.$eval(attrs.otherDate);
            if (otherDate && value) {
                if (attrs.validCanEqual) {
                    var isValid = moment(value).isSameOrBefore(moment(otherDate));
                    return isValid;
                }

                var isValid = moment(value).isBefore(moment(otherDate));
                return isValid;
            }
            return true;
        };
    };
}

angular
    .module("topline.directives")
    .directive(
        DateBeforeOtherDateValidationDirective.componentName,
        directiveFactory(DateBeforeOtherDateValidationDirective)
    );
